import { Environment } from "./enviroment.interface";

export const environment: Environment = {
  production: false,
  environment: 'SANDBOX',
  mfeBaseUrl: 'https://mfe.demo.ffdev.midassecure.com',
  loginCallbackPath: '/auth/callback',
  loginHostParamValue: 'matrix',
  matrixApiUrl: 'https://matrix-api.demo.ffdev.midassecure.com',
  shieldAppUrl: 'https://shield.demo.ffdev.midassecure.com/dashboard',
  alibiConfigUrl: 'https://dev.midassecure.com',
  alibiCurrentOrganizationUrl: 'https://dev.midassecure.com/api/organization/current',
  useMockedData: false,
};

